import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable, of, throwError} from "rxjs";
import {catchError} from "rxjs/operators";
import {NavigationService} from "../../navigation.service";
import {AuthenticationService} from "../../authentication/authentication.service";

@Injectable({providedIn: "root"})
export class NoConnectionHandler implements HttpInterceptor {

	constructor(private navigationService: NavigationService, private authService: AuthenticationService) {
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(catchError(error => {
			if (this.isConnectionError(error)) {
				if (this.authService.isLoggedIn()) {
					this.authService.logout();
				}

				this.navigationService.goToMaintenancePage();
				return of(error);
			}

			return throwError(error);
		}));
	}

	private isConnectionError(error: any) {
		if (error instanceof HttpErrorResponse) {
			let response = error as HttpErrorResponse;
			return response.status == null || response.status == 0;
		}

		return false;
	}
}
